module.exports = __webpack_public_path__ + "img/492.a771701c.jpg";